(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/menu/menu.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/menu/menu.js');
"use strict";


const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  LinkItem = _svs$ui$ReactItemsMen.LinkItem;
const menuItems = svs.ticket_partner.constants.menuItems;
const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation;
const _ref = svs.ticket_partner.constants.routes || {},
  LOGIN = _ref.LOGIN;
const Menu = _ref2 => {
  let _ref2$isLoggedIn = _ref2.isLoggedIn,
    isLoggedIn = _ref2$isLoggedIn === void 0 ? false : _ref2$isLoggedIn,
    _ref2$logout = _ref2.logout,
    logout = _ref2$logout === void 0 ? () => {} : _ref2$logout;
  const location = useLocation();
  return React.createElement(ItemsMenu, {
    branding: "neutral",
    centered: true,
    className: "items-menu-link-item-corp-demo",
    hiddenScrollbar: true,
    useScrollFaders: true,
    useScrollHelpers: true
  }, menuItems.map(item => {
    var _item$subUrls;
    const href = svs.core.data.baseUrl + item.url;
    return React.createElement(LinkItem, {
      Component: "a",
      href: href,
      key: href,
      label: item.displayName,
      onClick: () => {},
      selected: location.pathname === item.url || ((_item$subUrls = item.subUrls) === null || _item$subUrls === void 0 ? void 0 : _item$subUrls.includes(location.pathname))
    });
  }), isLoggedIn ? React.createElement(LinkItem, {
    label: "Logga ut",
    onClick: logout
  }) : React.createElement(LinkItem, {
    Component: "a",
    href: svs.core.data.baseUrl + LOGIN,
    label: "F\xF6retagsinloggning"
  }));
};
svs.ticket_partner.sharedComponents.menu.Menu = Menu;

 })(window);